import { type DictationStore } from './types';

type UniversalDictationRefreshState = Pick<
  DictationStore,
  'nativeDictationActive' | 'status'
>;

const listeners = new Set<() => void>();
let shouldBlockRefresh = false;

export const selectUniversalDictationShouldBlockRefresh = ({
  nativeDictationActive,
  status,
}: UniversalDictationRefreshState): boolean =>
  nativeDictationActive ||
  status === 'LISTENING' ||
  status === 'PROCESSING' ||
  status === 'INSERTION_ERROR';

/**
 * Publishes whether universal dictation has live capture, processing, or
 * recoverable transcript state through a tiny external-store facade. Recovery
 * UI can subscribe without pulling the recorder/transcription graph into its
 * healthy-path bundle.
 */
export const setUniversalDictationShouldBlockRefresh = (
  nextShouldBlockRefresh: boolean
): void => {
  if (shouldBlockRefresh === nextShouldBlockRefresh) return;

  shouldBlockRefresh = nextShouldBlockRefresh;
  listeners.forEach((listener) => listener());
};

export const universalDictationRefreshGuard = {
  getSnapshot: (): boolean => shouldBlockRefresh,
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
